var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.91 18.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d2a784;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#1b2c58;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.82,11.24c.16,1,.2,2.21,1.57,2.21h7.93c1.3,0,1.35-1.08,1.58-2L18.56,4.8H4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.89,15.93a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,13.89,15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.53,15.93a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,8.53,15.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.32,3.53H4.69L4.3.61A.63.63,0,0,0,3.58,0H.7A.7.7,0,0,0,0,.7a.7.7,0,0,0,.7.7H3l1.64,10c.27,1.71.66,3.37,2.89,3.37h7.7c2.26,0,2.5-1.61,2.91-3.23l1.72-6.87C20,4.1,20,3.53,19.32,3.53ZM17.92,6.7H8.39a.7.7,0,0,0-.7.7h0a.7.7,0,0,0,.7.7h9.18l-.4,1.6H10.1a.7.7,0,0,0-.7.7h0a.71.71,0,0,0,.7.7h6.72l-.07.29c-.23.89-.28,1.94-1.54,1.94H7.51c-1.33,0-1.37-1.2-1.52-2.15l-1-6.25H18.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.9547c1c497c57ff0fe28c3d8661a81b6.svg";
export { ForwardRef as ReactComponent };